import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';

//Services
import { DeclaracionService } from '../../../services/declaracion.service';
import { EntidadService } from '../../../services/entidad.service';
import { UserService } from '../../../services/user.service';
import { DjExcencionService } from '../../../services/dj1945/dj_excencion.service'
import { DjBienRaizService } from '../../../services/dj1945/dj_bien_raiz.service'
import { DjOpcionEntidadService } from '../../../services/dj1945/dj_opcion_entidad.service'
import { Global } from '../../../services/global';
import {Observable, Subject, Subscription} from "rxjs"

//Models
import { Declaracion } from '../../../models/declaracion';
import { DjIngresoGastoEntity } from '../../../models/dj1945/dj_ingreso_gasto_entity.model';
import { DjConfiguracionGlobalPeriodo } from '../../../models/dj1945/dj_configuracion_global_periodo.model';
import { TablePageInfo, TablePageRequest, TablePageResponse, TableTotalsInfo } from '../../../models/table_page.model';
import { DjRowResponse } from '../../../models/dj1945/dj_row_response.model';
import { DjExcencionModel } from '../../../models/dj1945/dj_excencion.model';
import { DjBienRaizModel } from '../../../models/dj1945/dj_bien_raiz.model';
import { DjOpcionEntidad, DjOpcionEntidadDto } from '../../../models/dj1945/dj_opcion_entidad.model'
import { error } from 'console';
import { SharingService } from '../../../services/sharing.service';

@Component({
  selector: 'app-verdeclaracion',
  templateUrl: './verdeclaracion.component.html',
  styleUrls: ['./verdeclaracion.component.css'],
  providers: [DeclaracionService, DjExcencionService, DjBienRaizService, DjOpcionEntidadService]
})
export class VerdeclaracionComponent implements OnInit {
  public titulo = "Ver Declaracion";
  public descripcion = "Declaraciones";
  public entidad_sel = this._entidadService.getEntidad();
  public declaracion;
  public declaraciones;
  public dec_ingresos_gastos;
  public dec_excenciones;
  public dec_bien_raiz;
  public SimpleChanges: any;
  public total_ingreso_gasto;
  public declaraciones_agrupadas;
  public resultados: number;
  public minified;
  public tipo = 101;
  public tipo_dec = "ing_gas";
  public url: string;
  public token;
  public parametros_importador = { rectificacion: false, num_rectificacion: '', entidad_sel: 0, year: 0 };
  public mensaje_num_rectificacion = "Ingrese el N° Rectificacón!"
  public descarga_txt = false
  public ver_duplicados = false
  public csv_thomson_reuters = false // Nueva propiedad para controlar descarga CSV

  public dj_config: DjConfiguracionGlobalPeriodo
  public dj_ingreso_gasto_entity_declaration: Array<DjIngresoGastoEntity>
  public page_info: TablePageInfo = {
    n_per_page: 15,
    page_number: 1,
    total_pages: 0,
    count_records: 0
  }
  public table_total_info: TableTotalsInfo
  public n_per_page: number = 10
  public djOpcionEntidad: DjOpcionEntidad
  public djOpcionEntidadDto: DjOpcionEntidadDto
  @ViewChild("num_rectificacion", { static: false }) nameField: ElementRef;
	public entidadSelSubscription: Subscription;
  public cargando_ingresos = false;
  public cargando_exenciones = false;
  public cargando_bienes = false;
  public cargando_excel = false;
  public cargando_csv = false;
  public cargando_thomson_reuters = false;
  
  // Configuración unificada del popup
  public popupConfig = {
    mostrar: false,
    procesando: true,
    titulo: '',
    subtitulo: '',
    icono: '',
    colorPrimario: '',
    colorSecundario: '',
    animacionClase: ''
  };
  
  public Math = Math; // Agregar Math para usar en el template
  private scrollbarWidth: number = 0; // Nueva propiedad

  // #region PROPIEDADES REGISTROS DUPLICADOS
  public mostrarRegistrosDuplicados: boolean = false;
  public hayRegistrosDuplicados: boolean = false;
  public cantidadRegistrosDuplicados: number = 0;
  // #endregion

  constructor(
    private _entidadService: EntidadService,
    private _declaracionService: DeclaracionService,
    private _excencionService: DjExcencionService,
    private _bienRaizService: DjBienRaizService,
    private _userService: UserService,
    private _sharingService: SharingService,
    private _opcionEntidadService: DjOpcionEntidadService
  ) {
    this.declaracion = new Declaracion('', '', 0, '', '', '');
    this.url = Global.url;
    this.token = this._userService.getToken();
    this.entidad_sel = this._entidadService.getEntidad();
    //this.trae_declaraciones(101);
    this.calculateScrollbarWidth();
  }

  ngOnInit() {
    this.getConfiguracionGlobalPeriodo()
    this.entidadSelSubscription = this._sharingService.sharingEntity.subscribe(
      (entidad) => {
        this.getConfiguracionGlobalPeriodo()
      }
    )
  }

  tipo_declaracion(tipo) {
    this.tipo_dec = tipo;
    
    // Reset estados de carga
    this.cargando_ingresos = false;
    this.cargando_exenciones = false;
    this.cargando_bienes = false;
    
    if (this.tipo_dec == 'ing_gas') {
      this.getConfiguracionGlobalPeriodo();
    } else if (this.tipo_dec == 'exenciones') {
      this.getExcenciones();
    } else if (this.tipo_dec == 'bien_raiz') {
      this.getBienesRaices();
    }
  }
  selTipoIngEgr(tipo) {
    this.tipo = tipo
    this.page_info.page_number = 1; // Reset a la primera página
    this.getConfiguracionGlobalPeriodo()
  }

  descargaArchivo() {
    if (this.parametros_importador.rectificacion == true &&
      (this.parametros_importador.num_rectificacion == '' || this.parametros_importador.num_rectificacion == '0' || !/^([0-9])*$/.test(this.parametros_importador.num_rectificacion))) {
      this.parametros_importador.num_rectificacion = ''
      this.mensaje_num_rectificacion = "Ingrese un N° Rectificación Valido!"
      this.nameField.nativeElement.focus()
    } else {
      this._declaracionService.exportarDeclaracionTxt(this.parametros_importador).subscribe(
        response => {
          var textFile = null

          this._declaracionService.getFile(response.nombre_archivo).subscribe(blob => {
            const a = document.createElement('a')
            const objectUrl = URL.createObjectURL(blob)
            a.href = objectUrl
            a.download = response.nombre_archivo;
            a.click();
            URL.revokeObjectURL(objectUrl);
          })
        })
    }
  }

  str2bytes(str: any) {
    var bytes = new Uint8Array(str.length);
    for (var i = 0; i < str.length; i++) {
      bytes[i] = str.charCodeAt(i);
    }
    return bytes;
  }

  rectificar() {
    if (this.parametros_importador.rectificacion == false) {
      this.parametros_importador.num_rectificacion = ''
    }
  }

  trae_declaraciones(tipo) {
    this.entidad_sel = this._entidadService.getEntidad();
    this.tipo = tipo;
    this._declaracionService.verDeclaracion(this.declaracion, tipo).subscribe(
      response => {
        this.resultados = 0
        this.descarga_txt = response.descarga_txt
        if (response.ingresos_gastos.length > 0) {
          this.resultados = response.total_ingreso_gasto[0].cantidad;
          this.declaraciones = response;
          this.dec_ingresos_gastos = response.ingresos_gastos;
          this.total_ingreso_gasto = response.total_ingreso_gasto[0].monto;
          this.dec_excenciones = response.excenciones;
          this.dec_bien_raiz = response.bien_raiz;
        } else {
          this.dec_ingresos_gastos = null;
          this.dec_excenciones = response.excenciones;
          this.dec_bien_raiz = response.bien_raiz;
        }
      },
      error => {
        console.error(error);
      }
    );
  }
  getBienesRaices() {
    this.dec_bien_raiz = null
    this.cargando_bienes = true
    const params: DjBienRaizModel = {
      periodo: this.dj_config.periodo,
      entidad: this.entidad_sel._id
    }
    
    this._bienRaizService.get(params).subscribe((response: DjRowResponse<Array<DjBienRaizModel>>) => {
      this.dec_bien_raiz = response.result;
      this.cargando_bienes = false
    }, (error) => { 
      this.cargando_bienes = false
      console.error(error); 
    })
  }

  getExcenciones() {
    this.dec_excenciones = null;
    this.cargando_exenciones = true
    const params: DjExcencionModel = {
      periodo: this.dj_config.periodo,
      entidad: this.entidad_sel._id
    }
    
    this._excencionService.get(params).subscribe((response: DjRowResponse<Array<DjExcencionModel>>) => {
      this.dec_excenciones = response.result;
      this.cargando_exenciones = false
    }, (error) => { 
      this.cargando_exenciones = false
      console.error(error); 
    })
  }

  // Método para ir a una página específica (simplificado)
  goToPage(page: number) {
    if (page >= 1 && page <= this.page_info.total_pages) {
      this.page_info.page_number = page;
      this.getConfiguracionGlobalPeriodo();
    }
  }

  // Método changePage simplificado
  changePage(operator: string) {
    if (operator == '+' && this.page_info.page_number < this.page_info.total_pages) {
      this.page_info.page_number++
    }
    else if (operator == '-' && this.page_info.page_number > 1) {
      this.page_info.page_number--
    }
    this.getConfiguracionGlobalPeriodo()
  }

  getForEntityPage(params: TablePageRequest<DjIngresoGastoEntity>) {
    this.total_ingreso_gasto = null
    this.resultados = null
    this.dj_ingreso_gasto_entity_declaration = null
    this.cargando_ingresos = true
    
    this._declaracionService.getForEntityPage(params).subscribe((response: TablePageResponse<DjIngresoGastoEntity>) => {
      this.dj_ingreso_gasto_entity_declaration = response.result
      this.page_info = response.page_info
      this.table_total_info = response.totals
      this.cargando_ingresos = false
      
      // Verificar que page_info tenga todas las propiedades necesarias
      if (!this.page_info.total_pages && this.page_info.count_records > 0) {
        this.page_info.total_pages = Math.ceil(this.page_info.count_records / this.page_info.n_per_page);
      }
      
      if (this.dj_ingreso_gasto_entity_declaration && this.dj_ingreso_gasto_entity_declaration.length) {
        const initialValue = 0;
        this.resultados = this.dj_ingreso_gasto_entity_declaration.reduce((accumulator, currentValue) => accumulator + currentValue.count,
          initialValue)
        this.total_ingreso_gasto = this.dj_ingreso_gasto_entity_declaration.reduce((accumulator, currentValue) => accumulator + currentValue.total,
          initialValue)
      }
    },
    (error) => { 
      this.cargando_ingresos = false
      console.error(error); 
    })
  }

  getConfiguracionGlobalPeriodo() {

    this._declaracionService.getGlobalConfiguration().subscribe(
      (response: DjRowResponse<DjConfiguracionGlobalPeriodo>) => {
        this.dj_config = response.result
        const params: TablePageRequest<DjIngresoGastoEntity> = {
          params: {
            periodo: this.dj_config.periodo, tipo_ing_egr: this.tipo, entidad: this.entidad_sel._id
          },
          page_info: this.page_info
        }
        this.djOpcionEntidadDto = {periodo: this.dj_config.periodo, entidad: this.entidad_sel._id}
        this.getOpcionEntidad(this.djOpcionEntidadDto)
        this.getForEntityPage(params)

      }, (error) => {
        console.error(error)
      })

  }

  getOpcionEntidad(params:DjOpcionEntidadDto){
    this.djOpcionEntidadDto = params
    this._opcionEntidadService.getOne(this.djOpcionEntidadDto).subscribe((response)=>{
      this.djOpcionEntidad = response
      this.descarga_txt = this.djOpcionEntidad?.validaciones?.descarga_txt || false
      this.ver_duplicados = this.djOpcionEntidad?.validaciones?.ver_duplicados || false
      this.csv_thomson_reuters = this.djOpcionEntidad?.validaciones?.csv_thomson_reuters || false
      
      // Verificar registros duplicados solo si está habilitado
      if (this.ver_duplicados) {
        this.verificarRegistrosDuplicados()
      } else {
        // Reset valores si no está habilitado
        this.hayRegistrosDuplicados = false;
        this.cantidadRegistrosDuplicados = 0;
      }
      
    }, error=>{ 
      console.error(error);
      // Valores por defecto en caso de error
      this.descarga_txt = false;
      this.ver_duplicados = false;
      this.csv_thomson_reuters = false;
      this.hayRegistrosDuplicados = false;
      this.cantidadRegistrosDuplicados = 0;
    })
  }

  private mostrarPopup(tipo: 'excel' | 'csv' | 'thomson') {
    const configuraciones = {
      excel: {
        titulo: 'Generando Excel',
        subtitulo: 'Procesando datos...',
        icono: 'fas fa-file-excel',
        colorPrimario: '#28a745',
        colorSecundario: 'success',
        animacionClase: 'excel'
      },
      csv: {
        titulo: 'Generando CSV',
        subtitulo: 'Preparando importador...',
        icono: 'fas fa-file-csv',
        colorPrimario: '#28a745',
        colorSecundario: 'success',
        animacionClase: 'csv'
      },
      thomson: {
        titulo: 'Thomson Reuters',
        subtitulo: 'Generando reporte...',
        icono: 'fas fa-chart-bar',
        colorPrimario: '#28a745',
        colorSecundario: 'success',
        animacionClase: 'thomson'
      }
    };
    
    this.popupConfig = {
      mostrar: true,
      procesando: true,
      ...configuraciones[tipo]
    };
  }

  private ocultarPopup() {
    this.popupConfig.mostrar = false;
    this.popupConfig.procesando = true; // Reset para próxima vez
  }

  downloadCsv(){
    this.mostrarPopup('csv');
    this._declaracionService.downloadCsv().subscribe(blob => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'importador.csv';
      link.click();
      window.URL.revokeObjectURL(link.href);
      this.ocultarPopup();
    }, error => {
      console.error('Error al descargar CSV:', error);
      this.ocultarPopup();
    });
  }

  downloadDjThomsonReuters(seccion){
    this.mostrarPopup('thomson');
    this._declaracionService.getDjThomsonReutersCSV(seccion).subscribe(blob => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'dj_1945_'+seccion.replace(/-/g, '_');
      link.click();
      window.URL.revokeObjectURL(link.href);
      this.ocultarPopup();
    }, error => {
      console.error('Error al descargar CSV:', error);
      this.ocultarPopup();
    });
  }

  downloadExcelDetail(){
    this.mostrarPopup('excel');
    this._declaracionService.downloadExcelDetail().subscribe(blob => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'detalle_declaraciones.xlsx';
      link.click();
      window.URL.revokeObjectURL(link.href);
      this.ocultarPopup();
    }, error => {
      console.error('Error al descargar Excel:', error);
      this.ocultarPopup();
    });
  }

  // Método para calcular el ancho real del scrollbar
  private calculateScrollbarWidth(): void {
    const outer = document.createElement('div');
    outer.style.visibility = 'hidden';
    outer.style.overflow = 'scroll';
    
    // Type assertion para propiedades específicas de IE
    (outer.style as any).msOverflowStyle = 'scrollbar';
    
    document.body.appendChild(outer);

    const inner = document.createElement('div');
    outer.appendChild(inner);

    this.scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    document.body.removeChild(outer);
  }

  // Método para obtener la compensación del scrollbar
  getScrollbarCompensation(): string {
    return this.scrollbarWidth > 0 ? `calc(100% - ${this.scrollbarWidth}px)` : '100%';
  }

  // #region MÉTODOS REGISTROS DUPLICADOS
  verificarRegistrosDuplicados() {
    // Simulamos la verificación - en la implementación real llamarías al servicio
    this._declaracionService.getDuplicateRecords().subscribe(
      (response: any) => {
        this.hayRegistrosDuplicados = response.result && response.result.length > 0;
        this.cantidadRegistrosDuplicados = response.result ? response.result.length : 0;
      },
      (error) => {
        this.hayRegistrosDuplicados = false;
        this.cantidadRegistrosDuplicados = 0;
        console.error(error);
      }
    );
  }

  verRegistrosDuplicados() {
    this.mostrarRegistrosDuplicados = true;
  }

  volverADeclaracion() {
    this.mostrarRegistrosDuplicados = false;
    
    // Volver a verificar registros duplicados solo si está habilitado
    if (this.ver_duplicados) {
      this.verificarRegistrosDuplicados();
    }
  }
  // #endregion

}
